<a href="#" style="display: none"></a>

<div class="modal-header">
    <h4 class="modal-title">{{'bcContestApplication_listTitle' | translate}}</h4>
</div>

<div class="modal-body">
    <div class="row">
        <div class="col data-value" *ngIf="course">
            <label>{{'bcContestApplication_lblSubject' | translate}}</label>
            <div>{{course.name}} ({{course.code}})</div>
        </div>

        <div class="col data-value" *ngIf="student">
            <label>{{'bcContestApplication_lblStudent' | translate}}</label>
            <div>{{student.name}} ({{student.upn}})</div>
        </div>
    </div>

    <app-table [rows]="items"
               [columns]="columns"
               [style]="'plain'"
               [page]="page"
               [pageSize]="pageSize"
               [total]="total"
               [auto]="autoPage"
               (pageChange)="onPage($event)"
               (sortChange)="onSort($event)">
        <ng-template #rowTemplate let-row>
            <tr>
                <td *ngIf="!student">
                    <div>
                        <a *ngIf="!isChild && !student; else noStudentLink" href="#" (click)="$event.preventDefault(); open(row)">{{row.StudentName}}</a>
                        <ng-template #noStudentLink>{{row.StudentName}}</ng-template>
                    </div>
                    <div class="text-sub">{{row.StudentUpn}}</div>
                    <div>{{row.Program}}</div>
                </td>
                <td *ngIf="!course">
                    <div class="student-course-info">
                        <div>{{row.Priority}}.</div>
                        <div>
                            <div>
                                <a *ngIf="!isChild && !course; else noCourseLink" href="#" (click)="$event.preventDefault(); open(row)">{{row.SubjectCode}}</a>
                                <ng-template #noCourseLink>{{row.SubjectCode}}</ng-template>
                            </div>
                            <div class="text-sub">{{row.SubjectName}}</div>
                        </div>
                    </div>
                </td>
                <td>{{row.Grade}}</td>
                <td>
                    <div class="text-nowrap" *ngIf="row.Place">{{row.Place}} {{'outOf' | translate}} {{row.GroupMaxSize}}</div>
                </td>
                <td>
                    <app-bc-contest-result [value]="row.AlgorithmResult"></app-bc-contest-result>
                </td>
                <td>
                    <app-bc-contest-result [value]="row.Result"></app-bc-contest-result>
                </td>
                <td>
                    <ng-container *ngIf="row.Submitted">{{row.Submitted | appDate:'datetime'}}</ng-container>
                    <div class="text-danger" *ngIf="row.SubmitError">{{row.SubmitError}}</div>
                </td>
                <td>
                    <div class="table-actions">
                        <button type="button" class="btn btn-outline btn-icon" [ngbTooltip]="'edit' | translate"
                                (click)="edit(row)" *ngIf="!isReadOnly && canEdit">
                            <i class="fi fi-rs-pencil"></i>
                        </button>
                    </div>
                </td>
            </tr>
        </ng-template>
    </app-table>
</div>

<div class="modal-footer">
    <button class="btn btn-outline-secondary" (click)="close()" type="button">{{'dialog_close' | translate}}</button>
</div>
